import {
  PERMISSION_ACTION_ADD,
  PERMISSION_ACTION_DELETE,
  PERMISSION_ACTION_VIEW,
  PERMISSION_ENTITY_PLATFORM_FEE,
  type PermissionAction
} from '@klear/constants'
import { ORDER_EVENT_STATUS_PUBLISHED } from '@klear/constants/order-event-status'
import type { OrderEventStatusLabelsFor } from '@klear/order-event-lifecycle/lifecycle'

export const FEE_STATUS_LABELS = {
  [ORDER_EVENT_STATUS_PUBLISHED]: 'Published'
} as const satisfies OrderEventStatusLabelsFor<typeof PERMISSION_ENTITY_PLATFORM_FEE>

export const FEE_ACTION_LABELS = {
  [PERMISSION_ACTION_VIEW]: 'View',
  [PERMISSION_ACTION_ADD]: 'Add',
  [PERMISSION_ACTION_DELETE]: 'Delete'
} as const satisfies Partial<Record<PermissionAction, string>>
